module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "app-footer__row flex"
  }, [_c('p', [_c('i', {
    staticClass: "fas fa-code-branch",
    staticStyle: {
      "margin-right": "5px",
      "font-size": "11px"
    }
  }), _vm._v(" Ver " + _vm._s(_vm.buildInfo.buildDate) + "\n        "), _c('a', {
    staticStyle: {
      "color": "white",
      "margin-left": "35px"
    },
    attrs: {
      "href": "https://fast.com",
      "target": "_blank"
    }
  }, [_vm._v("SpeedTest")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "color": "white",
      "margin-left": "35px"
    },
    attrs: {
      "to": "/admin/feedback"
    }
  }, [_vm._v("Feedback")])], 1), _vm._v(" "), (_vm.servernetwork == 'slow' && !_vm.servernetworkFailure) ? _c('div', {
    staticClass: "flex"
  }, [_vm._m(0), _vm._v("     "), _c('div', {
    staticClass: "led-yellow"
  })]) : _vm._e(), _vm._v(" "), (_vm.servernetwork == 'fast' && _vm.servernetworkFailure) ? _c('div', {
    staticClass: "flex"
  }, [_vm._m(1), _vm._v("     "), _c('div', {
    staticClass: "led-red"
  })]) : _vm._e(), _vm._v(" "), (_vm.network == 'slow' && !_vm.networkFailure) ? _c('div', {
    staticClass: "flex"
  }, [_vm._m(2), _vm._v("     "), _c('div', {
    staticClass: "led-yellow"
  })]) : _vm._e(), _vm._v(" "), (_vm.network == 'fast' && _vm.networkFailure) ? _c('div', {
    staticClass: "flex"
  }, [_vm._m(3), _vm._v("     "), _c('div', {
    staticClass: "led-red"
  })]) : _vm._e(), _vm._v(" "), (_vm.liveRunSpeakerAPIFail) ? _c('div', {
    staticClass: "flex"
  }, [_vm._m(4), _vm._v("     "), _c('div', {
    staticClass: "led-red"
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', [_c('router-link', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "to": "/admin/active-run"
    }
  }, [_vm._v("Active Run : " + _vm._s(_vm.activeRun))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex auto-pilot-indicator"
  }, [_c('p', {
    staticClass: "deadnet"
  }, [_c('span', {
    staticClass: "robot-icon",
    class: {
      'animate-robot': _vm.isStartingSoon
    }
  }, [_c('i', {
    staticClass: "fas fa-robot"
  })]), _vm._v("\n          LiveRun Bot:\n          "), (_vm.nextAutoPilotRun) ? _c('span', [_c('span', {
    staticClass: "autopilot-run",
    on: {
      "click": function($event) {
        _vm.goToRace(_vm.nextAutoPilotRun.raceId)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.nextAutoPilotRun.name) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "countdown"
  }, [_vm._v("(" + _vm._s(_vm.formatTimeRemaining) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "autopilot-message"
  }, [_vm._v("- This run is being handled in autopilot mode")])]) : _c('span', {
    staticClass: "no-runs"
  }, [_vm._v("No upcoming runs in next 5 days on AutoPilot")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "deadnet"
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("⚠")]), _vm._v(" Console API Slow")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "deadnet"
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("⚠")]), _vm._v(" Console API Disconnected")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "deadnet"
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("⚠")]), _vm._v(" Network Slow")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "deadnet"
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("⚠")]), _vm._v(" Network Disconnected")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "deadnet"
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("⚠")]), _vm._v(" LiveRun Speaker API Down")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0812f622"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter/AppFooter.vue
// module id = 1766
// module chunks = 1